<script>
  import { db } from "../etc/firebase.js"
  import "materialize-css"

  export let id = ""
  export let note = {}

  document.addEventListener("DOMContentLoaded", function () {
    var modals = document.querySelectorAll(".modal")
    M.Modal.init(modals)

    var items = document.querySelectorAll(".collapsible")
    M.Collapsible.init(items)
  })

  const deleteNote = () => {
    db.collection("notes").doc(id).delete()
  }

  const updateNote = () => {
    db.collection("notes").doc(id).update({
      updatedDT: note.updatedDT,
      title: note.title,
      publicNote: note.publicNote,
      content: note.content,
    })
  }
</script>

<li>
  <div class="collapsible-header grey lighten-4">{note.title}</div>
  <div class="collapsible-body white">
    <span>{note.content}</span>
    <button
      class="waves-effect waves-light orange darken-2 btn"
      on:click={updateNote}
      style="color: blue">Update</button
    >
    <button on:click={deleteNote} style="color: red">X</button>
  </div>
</li>

<style>
  .note {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 10px;
  }
</style>
